(function () {
  'use strict';

  if (window.JerseysCompanyCustomizer) {
    window.JerseysCompanyCustomizer.init();
    return;
  }

  const Customizer = {
    init() {
      document
        .querySelectorAll('[data-jc-customizer]')
        .forEach((root) => {
          this.initRoot(root);
        });
    },

    initRoot(root) {
      if (root.dataset.jcCustomizerReady === 'true') {
        return;
      }

      const modal = root.querySelector(
        '[data-jc-customizer-modal]'
      );

      const openButton = root.querySelector(
        '[data-jc-customizer-open]'
      );

      if (!modal || !openButton) {
        return;
      }

      root.dataset.jcCustomizerReady = 'true';

      /*
        Remove modais duplicados que podem ser criados
        ao recarregar a seção no editor da Shopify.
      */

      document
        .querySelectorAll(`#${modal.id}`)
        .forEach((existingModal) => {
          if (existingModal !== modal) {
            existingModal.remove();
          }
        });

      /*
        Move o modal para o body para evitar problemas
        com position, overflow e transform da página.
      */

      document.body.appendChild(modal);

      const panel = modal.querySelector(
        '[data-jc-customizer-panel]'
      );

      const closeButtons = modal.querySelectorAll(
        '[data-jc-customizer-close]'
      );

      const nameInput = modal.querySelector(
        '[data-jc-custom-name]'
      );

      const numberInput = modal.querySelector(
        '[data-jc-custom-number]'
      );

      const patchInput = modal.querySelector(
        '[data-jc-custom-patch]'
      );

      const patchCard = modal.querySelector(
        '[data-jc-patch-card]'
      );

      const nameCounter = modal.querySelector(
        '[data-jc-name-counter]'
      );

      const numberCounter = modal.querySelector(
        '[data-jc-number-counter]'
      );

      const totalElement = modal.querySelector(
        '[data-jc-customizer-total]'
      );

      const addButton = modal.querySelector(
        '[data-jc-customizer-add]'
      );

      const addButtonText = modal.querySelector(
        '[data-jc-customizer-add-text]'
      );

      const spinner = modal.querySelector(
        '[data-jc-customizer-spinner]'
      );

      const errorElement = modal.querySelector(
        '[data-jc-customizer-error]'
      );

      const customizationVariantId = Number(
        root.dataset.customizationVariantId
      );

      const patchVariantId = Number(
        root.dataset.patchVariantId
      );

      const customizationUnitPrice = Number(
        root.dataset.customizationUnitPrice || 5
      );

      const patchUnitPrice = Number(
        root.dataset.patchUnitPrice || 10
      );

      const customizationBaseQuantity = Number(
        root.dataset.customizationBaseQuantity || 1
      );

      const productTitle =
        root.dataset.productTitle || '';

      let previousFocus = null;


      /* =====================================================
         SANITIZAÇÃO
         ===================================================== */

      function sanitizeName(value) {
        return String(value || '')
          .replace(/[<>]/g, '')
          .toUpperCase()
          .slice(0, 15);
      }


      function sanitizeNumber(value) {
        return String(value || '')
          .replace(/\D/g, '')
          .slice(0, 3);
      }


      function getName() {
        return nameInput
          ? sanitizeName(nameInput.value.trim())
          : '';
      }


      function getNumber() {
        return numberInput
          ? sanitizeNumber(numberInput.value.trim())
          : '';
      }


      function hasPatch() {
        return Boolean(
          patchInput &&
          patchInput.checked
        );
      }


      function formatMoney(amount) {
        return `$${Number(amount).toFixed(2)}`;
      }


      /* =====================================================
         PRODUTO E FORMULÁRIO
         ===================================================== */

      function getProductScope() {
        return (
          root.closest('product-info') ||
          root.closest('[id^="MainProduct-"]') ||
          root.closest('.product') ||
          document
        );
      }


      function getProductForm() {
        const scope = getProductScope();

        const forms = Array.from(
          scope.querySelectorAll(
            'form[action*="/cart/add"]'
          )
        );

        return (
          forms.find((form) => {
            return (
              !form.classList.contains('installment') &&
              form.querySelector('[name="id"]')
            );
          }) || null
        );
      }


      function getVariantId(form) {
        if (!form) {
          return null;
        }

        const variantInput = form.querySelector(
          'input[name="id"], select[name="id"]'
        );

        if (
          !variantInput ||
          !variantInput.value
        ) {
          return null;
        }

        const variantId = Number(
          variantInput.value
        );

        return Number.isFinite(variantId)
          ? variantId
          : null;
      }


      function getProductQuantity(form) {
        const scope = getProductScope();

        const quantityInput =
          form?.querySelector(
            'input[name="quantity"]'
          ) ||
          scope.querySelector(
            'input[name="quantity"]'
          );

        const quantity = Number.parseInt(
          quantityInput?.value || '1',
          10
        );

        return (
          Number.isFinite(quantity) &&
          quantity > 0
        )
          ? quantity
          : 1;
      }


      function getSellingPlan(form) {
        if (!form) {
          return null;
        }

        const sellingPlanInput =
          form.querySelector(
            '[name="selling_plan"]'
          );

        if (
          !sellingPlanInput ||
          !sellingPlanInput.value
        ) {
          return null;
        }

        const sellingPlan = Number(
          sellingPlanInput.value
        );

        return Number.isFinite(sellingPlan)
          ? sellingPlan
          : null;
      }


      function collectExistingProperties(form) {
        const properties = {};

        if (!form) {
          return properties;
        }

        const formData = new FormData(form);

        formData.forEach((value, key) => {
          const match = key.match(
            /^properties\[(.+)\]$/
          );

          if (!match) {
            return;
          }

          const propertyName = match[1];

          const propertyValue = String(
            value || ''
          ).trim();

          if (propertyValue) {
            properties[propertyName] =
              propertyValue;
          }
        });

        return properties;
      }


      function collectSelectedOptions() {
        const scope = getProductScope();
        const selectedOptions = [];

        scope
          .querySelectorAll(
            'fieldset.product-form__input'
          )
          .forEach((fieldset) => {
            const checkedInput =
              fieldset.querySelector(
                'input[type="radio"]:checked'
              );

            if (!checkedInput) {
              return;
            }

            const legend =
              fieldset.querySelector('legend');

            const optionName = legend
              ? legend.textContent
                  .replace(':', '')
                  .trim()
              : 'Option';

            selectedOptions.push(
              `${optionName}: ${checkedInput.value}`
            );
          });

        scope
          .querySelectorAll(
            'variant-selects select'
          )
          .forEach((select) => {
            const label = select.id
              ? scope.querySelector(
                  `label[for="${select.id}"]`
                )
              : null;

            const optionName = label
              ? label.textContent
                  .replace(':', '')
                  .trim()
              : select.name || 'Option';

            selectedOptions.push(
              `${optionName}: ${select.value}`
            );
          });

        return Array.from(
          new Set(selectedOptions)
        ).join(' | ');
      }


      function getCustomizationQuantity(
        productQuantity
      ) {
        return (
          customizationBaseQuantity *
          productQuantity
        );
      }


      /* =====================================================
         SHOPIFY STANDARD STOREFRONT EVENTS
         ===================================================== */

      function getStandardEvents() {
        return (
          window.StandardEvents ||
          window.Shopify?.StandardEvents ||
          null
        );
      }


      function getCartEventTarget(
        productForm
      ) {
        return (
          root.closest('product-info') ||
          root.closest('[id^="MainProduct-"]') ||
          productForm ||
          root
        );
      }


      function createCartLinesAddEvent(
        items,
        productForm
      ) {
        const standardEvents =
          getStandardEvents();

        const CartLinesUpdateEvent =
          standardEvents?.CartLinesUpdateEvent;

        if (
          !CartLinesUpdateEvent ||
          !Array.isArray(items) ||
          !items.length
        ) {
          return null;
        }

        const deferred =
          CartLinesUpdateEvent.createPromise();

        const eventTarget =
          getCartEventTarget(
            productForm
          );

        const lines = items
          .filter((item) => {
            return (
              item &&
              item.id &&
              item.quantity > 0
            );
          })
          .map((item) => {
            return {
              merchandiseId:
                item.id,
              quantity:
                item.quantity
            };
          });

        if (!lines.length) {
          return null;
        }

        eventTarget.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines,
            promise:
              deferred.promise
          })
        );

        return {
          deferred,
          CartLinesUpdateEvent,
          eventTarget
        };
      }


      async function resolveCartLinesAddEvent(
        eventState
      ) {
        if (!eventState) {
          return;
        }

        try {
          const rootRoute =
            window.Shopify?.routes?.root ||
            '/';

          const response = await fetch(
            `${rootRoute}cart.js`,
            {
              method: 'GET',
              headers: {
                Accept:
                  'application/json'
              },
              credentials:
                'same-origin'
            }
          );

          if (!response.ok) {
            throw new Error(
              'Unable to load the updated cart for the Shopify standard event.'
            );
          }

          const ajaxCart =
            await response.json();

          eventState.deferred.resolve({
            cart:
              eventState
                .CartLinesUpdateEvent
                .createCartFromAjaxResponse(
                  ajaxCart
                )
          });
        } catch (error) {
          eventState.deferred.reject(
            error
          );

          console.warn(
            'Jerseys Company: cart was added, but the standard cart event could not be resolved.',
            error
          );
        }
      }


      function rejectCartLinesAddEvent(
        eventState,
        error
      ) {
        if (!eventState) {
          return;
        }

        try {
          eventState.deferred.reject(
            error
          );
        } catch (rejectError) {
          console.warn(
            'Jerseys Company: unable to reject the standard cart event promise.',
            rejectError
          );
        }
      }


      function dispatchCartErrorEvent(
        productForm,
        error,
        code
      ) {
        const standardEvents =
          getStandardEvents();

        const CartErrorEvent =
          standardEvents?.CartErrorEvent;

        if (!CartErrorEvent) {
          return;
        }

        const eventTarget =
          getCartEventTarget(
            productForm
          );

        eventTarget.dispatchEvent(
          new CartErrorEvent({
            error:
              error?.message ||
              'Unable to add this product to the cart.',
            code:
              code ||
              'SERVICE_UNAVAILABLE'
          })
        );
      }


      /* =====================================================
         TOTAL
         ===================================================== */

      function calculateTotal() {
        const productForm =
          getProductForm();

        const productQuantity =
          getProductQuantity(productForm);

        let total = 0;

        if (
          getName() ||
          getNumber()
        ) {
          total +=
            customizationUnitPrice *
            getCustomizationQuantity(
              productQuantity
            );
        }

        if (hasPatch()) {
          total +=
            patchUnitPrice *
            productQuantity;
        }

        return total;
      }


      /* =====================================================
         MENSAGENS
         ===================================================== */

      function showError(message) {
        if (!errorElement) {
          return;
        }

        errorElement.textContent =
          message;

        errorElement.hidden = false;
      }


      function clearError() {
        if (!errorElement) {
          return;
        }

        errorElement.textContent = '';
        errorElement.hidden = true;
      }


      function updateInterface() {
        const name = getName();
        const number = getNumber();

        if (nameInput) {
          nameInput.value = name;
        }

        if (numberInput) {
          numberInput.value = number;
        }

        if (nameCounter) {
          nameCounter.textContent =
            `${name.length}/15`;
        }

        if (numberCounter) {
          numberCounter.textContent =
            `${number.length}/3`;
        }

        if (patchCard) {
          patchCard.classList.toggle(
            'is-selected',
            hasPatch()
          );
        }

        if (totalElement) {
          totalElement.textContent =
            `+ ${formatMoney(
              calculateTotal()
            )}`;
        }

        clearError();
      }


      function setLoading(isLoading) {
        if (!addButton) {
          return;
        }

        addButton.disabled = isLoading;

        if (spinner) {
          spinner.hidden = !isLoading;
        }

        if (addButtonText) {
          addButtonText.textContent =
            isLoading
              ? 'Adding...'
              : 'Add To Cart';
        }
      }


      /* =====================================================
         MODAL
         ===================================================== */

      function getFocusableElements() {
        return Array.from(
          modal.querySelectorAll(
            [
              'button:not([disabled])',
              'input:not([disabled])',
              'select:not([disabled])',
              'textarea:not([disabled])',
              'a[href]',
              '[tabindex]:not([tabindex="-1"])'
            ].join(',')
          )
        ).filter((element) => {
          return (
            element.offsetWidth > 0 ||
            element.offsetHeight > 0
          );
        });
      }


      function openModal() {
        document
          .querySelectorAll(
            '.jc-customizer-modal.is-open'
          )
          .forEach((openModalElement) => {
            if (
              openModalElement !== modal
            ) {
              openModalElement.classList.remove(
                'is-open'
              );

              openModalElement.setAttribute(
                'aria-hidden',
                'true'
              );
            }
          });

        previousFocus =
          document.activeElement;

        modal.classList.add('is-open');

        modal.setAttribute(
          'aria-hidden',
          'false'
        );

        openButton.setAttribute(
          'aria-expanded',
          'true'
        );

        document.body.classList.add(
          'jc-customizer-body-lock'
        );

        updateInterface();

        window.requestAnimationFrame(() => {
          if (nameInput) {
            nameInput.focus();
          } else if (panel) {
            panel.focus();
          }
        });
      }


      function closeModal() {
        modal.classList.remove('is-open');

        modal.setAttribute(
          'aria-hidden',
          'true'
        );

        openButton.setAttribute(
          'aria-expanded',
          'false'
        );

        document.body.classList.remove(
          'jc-customizer-body-lock'
        );

        clearError();

        if (
          previousFocus &&
          typeof previousFocus.focus ===
            'function'
        ) {
          previousFocus.focus();
        }
      }


      /* =====================================================
         CART DRAWER
         ===================================================== */

      function getCartDrawer() {
        return document.querySelector(
          'cart-drawer'
        );
      }


      function getCartSectionDescriptors(
        cartDrawer
      ) {
        if (
          cartDrawer &&
          typeof cartDrawer.getSectionsToRender ===
            'function'
        ) {
          try {
            const nativeSections =
              cartDrawer.getSectionsToRender();

            if (
              Array.isArray(nativeSections) &&
              nativeSections.length
            ) {
              return nativeSections.map(
                (descriptor) => {
                  return {
                    ...descriptor,
                    section:
                      descriptor.section ||
                      descriptor.id,
                    selector:
                      descriptor.selector ||
                      null
                  };
                }
              );
            }
          } catch (error) {
            console.warn(
              'Jerseys Company: unable to read native cart sections.',
              error
            );
          }
        }

        /*
          Fallback compatível com Dawn.
        */

        return [
          {
            id: 'cart-drawer',
            section: 'cart-drawer',
            selector: '#CartDrawer'
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: null
          }
        ];
      }


      function getCartSectionNames(
        cartDrawer
      ) {
        return Array.from(
          new Set(
            getCartSectionDescriptors(
              cartDrawer
            )
              .map((descriptor) => {
                return descriptor.section;
              })
              .filter(Boolean)
          )
        );
      }


      function parseSectionHTML(html) {
        return new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );
      }


      function findCurrentSectionElement(
        descriptor
      ) {
        const elementById =
          descriptor.id
            ? document.getElementById(
                descriptor.id
              )
            : null;

        if (descriptor.selector) {
          if (elementById) {
            if (
              elementById.matches(
                descriptor.selector
              )
            ) {
              return elementById;
            }

            const nestedElement =
              elementById.querySelector(
                descriptor.selector
              );

            if (nestedElement) {
              return nestedElement;
            }
          }

          const selectedElement =
            document.querySelector(
              descriptor.selector
            );

          if (selectedElement) {
            return selectedElement;
          }
        }

        return elementById;
      }


      function findIncomingSectionElement(
        sectionHTML,
        descriptor
      ) {
        if (!sectionHTML) {
          return null;
        }

        const parsedDocument =
          parseSectionHTML(sectionHTML);

        const elementById =
          descriptor.id
            ? parsedDocument.getElementById(
                descriptor.id
              )
            : null;

        if (descriptor.selector) {
          if (elementById) {
            if (
              elementById.matches(
                descriptor.selector
              )
            ) {
              return elementById;
            }

            const nestedElement =
              elementById.querySelector(
                descriptor.selector
              );

            if (nestedElement) {
              return nestedElement;
            }
          }

          const selectedElement =
            parsedDocument.querySelector(
              descriptor.selector
            );

          if (selectedElement) {
            return selectedElement;
          }
        }

        if (elementById) {
          return elementById;
        }

        return (
          parsedDocument.body
            .firstElementChild || null
        );
      }


      function bindDrawerOverlay(
        cartDrawer
      ) {
        if (
          !cartDrawer ||
          typeof cartDrawer.close !==
            'function'
        ) {
          return;
        }

        const overlay =
          cartDrawer.querySelector(
            '#CartDrawer-Overlay'
          );

        if (
          !overlay ||
          overlay.dataset.jcCloseReady ===
            'true'
        ) {
          return;
        }

        overlay.dataset.jcCloseReady =
          'true';

        overlay.addEventListener(
          'click',
          () => {
            cartDrawer.close();
          }
        );
      }


      function renderCartSectionsManually(
        cartDrawer,
        sections
      ) {
        if (!sections) {
          return false;
        }

        const descriptors =
          getCartSectionDescriptors(
            cartDrawer
          );

        let updated = false;

        descriptors.forEach(
          (descriptor) => {
            const sectionHTML =
              sections[
                descriptor.section
              ];

            if (!sectionHTML) {
              return;
            }

            const currentElement =
              findCurrentSectionElement(
                descriptor
              );

            const incomingElement =
              findIncomingSectionElement(
                sectionHTML,
                descriptor
              );

            if (
              !currentElement ||
              !incomingElement
            ) {
              return;
            }

            currentElement.innerHTML =
              incomingElement.innerHTML;

            updated = true;
          }
        );

        if (updated) {
          bindDrawerOverlay(cartDrawer);
        }

        return updated;
      }


      function renderCartDrawer(
        cartDrawer,
        responseData
      ) {
        if (
          !responseData ||
          !responseData.sections
        ) {
          return false;
        }

        /*
          Primeira tentativa:
          método nativo do cart drawer.
        */

        if (
          cartDrawer &&
          typeof cartDrawer.renderContents ===
            'function'
        ) {
          try {
            cartDrawer.renderContents(
              responseData
            );

            return true;
          } catch (error) {
            console.warn(
              'Jerseys Company: native cart drawer render failed.',
              error
            );
          }
        }

        /*
          Segunda tentativa:
          atualização manual das seções.
        */

        return renderCartSectionsManually(
          cartDrawer,
          responseData.sections
        );
      }


      function openCartDrawer(
        originalCartDrawer
      ) {
        window.setTimeout(() => {
          const cartDrawer =
            getCartDrawer() ||
            originalCartDrawer;

          if (
            cartDrawer &&
            typeof cartDrawer.open ===
              'function'
          ) {
            bindDrawerOverlay(
              cartDrawer
            );

            cartDrawer.open();
            return;
          }

          /*
            Só aciona o ícone quando um cart drawer
            realmente existe na página.

            Dessa forma, o link não redireciona
            para /cart.
          */

          const existingDrawer =
            document.querySelector(
              'cart-drawer'
            );

          const cartIcon =
            document.getElementById(
              'cart-icon-bubble'
            );

          if (
            existingDrawer &&
            cartIcon
          ) {
            cartIcon.click();
          }
        }, 160);
      }


      /* =====================================================
         ADICIONAR AO CARRINHO
         ===================================================== */

      async function addToCart() {
        clearError();

        const productForm =
          getProductForm();

        const selectedVariantId =
          getVariantId(productForm);

        if (!selectedVariantId) {
          showError(
            'Please select the jersey size and options before adding it to the cart.'
          );

          return;
        }

        const productQuantity =
          getProductQuantity(
            productForm
          );

        const sellingPlan =
          getSellingPlan(productForm);

        const name = getName();
        const number = getNumber();

        const patchSelected =
          hasPatch();

        const hasCustomization =
          Boolean(name || number);

        const selectedOptions =
          collectSelectedOptions();

        const customizationGroup = [
          'JC',
          Date.now().toString(36),
          Math.random()
            .toString(36)
            .slice(2, 8)
        ]
          .join('-')
          .toUpperCase();

        const existingProperties =
          collectExistingProperties(
            productForm
          );

        const mainProperties = {
          ...existingProperties
        };

        if (
          hasCustomization ||
          patchSelected
        ) {
          mainProperties[
            '_Customization_Group'
          ] = customizationGroup;
        }

        if (name) {
          mainProperties[
            'Name on Shirt'
          ] = name;
        }

        if (number) {
          mainProperties.Number =
            number;
        }

        if (patchSelected) {
          mainProperties[
            'Tournament Patch'
          ] =
            'Mexico USA Canada 2026 World Cup Set';
        }


        /*
          Produto principal.
        */

        const mainItem = {
          id: selectedVariantId,
          quantity: productQuantity
        };

        if (
          Object.keys(
            mainProperties
          ).length
        ) {
          mainItem.properties =
            mainProperties;
        }

        if (sellingPlan) {
          mainItem.selling_plan =
            sellingPlan;
        }

        const items = [mainItem];


        if (
          hasCustomization &&
          !Number.isFinite(
            customizationVariantId
          )
        ) {
          showError(
            'Customization is temporarily unavailable. Please refresh the page and try again.'
          );

          return;
        }

        if (
          patchSelected &&
          !Number.isFinite(
            patchVariantId
          )
        ) {
          showError(
            'The tournament patch is temporarily unavailable. Please refresh the page and try again.'
          );

          return;
        }


        /*
          Produto de personalização.

          Produto normal:
          1 unidade de US$ 5 por camisa.

          Combo Kit:
          3 unidades de US$ 5 por kit.
        */

        if (hasCustomization) {
          const customizationQuantity =
            getCustomizationQuantity(
              productQuantity
            );

          const customizationProperties = {
            'Customization For':
              productTitle,

            'Name on Shirt':
              name || 'Not selected',

            Number:
              number || 'Not selected',

            'Customization Units':
              String(
                customizationQuantity
              ),

            _Customization_Group:
              customizationGroup
          };

          if (selectedOptions) {
            customizationProperties[
              'Selected Options'
            ] = selectedOptions;
          }

          items.push({
            id: customizationVariantId,
            quantity:
              customizationQuantity,
            properties:
              customizationProperties
          });
        }


        /*
          Produto do patch.
        */

        if (patchSelected) {
          const patchProperties = {
            'Patch For':
              productTitle,

            _Customization_Group:
              customizationGroup
          };

          if (selectedOptions) {
            patchProperties[
              'Selected Options'
            ] = selectedOptions;
          }

          items.push({
            id: patchVariantId,
            quantity:
              productQuantity,
            properties:
              patchProperties
          });
        }


        /*
          Solicita ao Shopify o HTML atualizado
          do drawer e do contador do carrinho.
        */

        const cartDrawer =
          getCartDrawer();

        const cartSections =
          getCartSectionNames(
            cartDrawer
          );

        const requestBody = {
          items,
          sections: cartSections,
          sections_url:
            window.location.pathname
        };

        setLoading(true);

        let cartLinesEventState =
          null;

        try {
          /*
            Dispara o evento padronizado ANTES da
            mutação AJAX, conforme o padrão da Shopify.

            Como este customizador não envia o
            product-form nativo, o evento precisa
            ser emitido aqui para evitar que o
            Add to Cart customizado fique invisível
            para integrações que escutam a camada
            de Standard Storefront Events.
          */

          cartLinesEventState =
            createCartLinesAddEvent(
              items,
              productForm
            );

          const rootRoute =
            window.Shopify?.routes?.root ||
            '/';

          const cartAddUrl =
            window.routes?.cart_add_url ||
            `${rootRoute}cart/add.js`;

          const response = await fetch(
            cartAddUrl,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },

              credentials:
                'same-origin',

              body:
                JSON.stringify(
                  requestBody
                )
            }
          );

          const responseData =
            await response.json();

          if (!response.ok) {
            const addError =
              new Error(
                responseData.description ||
                responseData.message ||
                'Unable to add this product to the cart.'
              );

            addError.code =
              response.status === 422
                ? 'INVALID'
                : 'SERVICE_UNAVAILABLE';

            throw addError;
          }


          /*
            Resolve a promise do evento com o
            carrinho COMPLETO pós-mutação.

            /cart/add.js retorna os itens adicionados,
            não o objeto completo do carrinho.
          */

          await resolveCartLinesAddEvent(
            cartLinesEventState
          );


          /*
            Limpa os campos depois da confirmação.
          */

          if (nameInput) {
            nameInput.value = '';
          }

          if (numberInput) {
            numberInput.value = '';
          }

          if (patchInput) {
            patchInput.checked = false;
          }

          updateInterface();


          /*
            Atualiza o drawer antes de fechar
            o customizador.
          */

          const drawerUpdated =
            renderCartDrawer(
              cartDrawer,
              responseData
            );

          if (!drawerUpdated) {
            console.warn(
              'Jerseys Company: products were added, but the cart drawer sections could not be rendered.'
            );
          }


          /*
            Fecha o modal de personalização e
            abre o cart drawer.

            Não existe redirecionamento para /cart.
          */

          closeModal();

          openCartDrawer(
            cartDrawer
          );


          /*
            Evento para integrações adicionais
            da loja.
          */

          document.dispatchEvent(
            new CustomEvent(
              'jc:cart-updated',
              {
                bubbles: true,
                detail: responseData
              }
            )
          );
        } catch (error) {
          rejectCartLinesAddEvent(
            cartLinesEventState,
            error
          );

          dispatchCartErrorEvent(
            productForm,
            error,
            error?.code ||
              'SERVICE_UNAVAILABLE'
          );

          console.error(
            'Jerseys Company Customizer:',
            error
          );

          showError(
            error.message ||
            'An error occurred while adding the product.'
          );
        } finally {
          setLoading(false);
        }
      }


      /* =====================================================
         EVENTOS
         ===================================================== */

      openButton.addEventListener(
        'click',
        openModal
      );


      closeButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            closeModal
          );
        }
      );


      modal.addEventListener(
        'click',
        (event) => {
          if (event.target === modal) {
            closeModal();
          }
        }
      );


      modal.addEventListener(
        'keydown',
        (event) => {
          if (
            !modal.classList.contains(
              'is-open'
            )
          ) {
            return;
          }

          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') {
            return;
          }

          const focusableElements =
            getFocusableElements();

          if (!focusableElements.length) {
            event.preventDefault();

            if (panel) {
              panel.focus();
            }

            return;
          }

          const firstElement =
            focusableElements[0];

          const lastElement =
            focusableElements[
              focusableElements.length - 1
            ];

          if (
            event.shiftKey &&
            document.activeElement ===
              firstElement
          ) {
            event.preventDefault();
            lastElement.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement ===
              lastElement
          ) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      );


      nameInput?.addEventListener(
        'input',
        updateInterface
      );


      numberInput?.addEventListener(
        'input',
        updateInterface
      );


      patchInput?.addEventListener(
        'change',
        updateInterface
      );


      addButton?.addEventListener(
        'click',
        addToCart
      );


      const productScope =
        getProductScope();

      productScope.addEventListener(
        'change',
        (event) => {
          if (
            event.target.matches(
              [
                'input[name="quantity"]',
                'input[type="radio"]',
                'select'
              ].join(',')
            )
          ) {
            updateInterface();
          }
        }
      );


      updateInterface();
    }
  };


  window.JerseysCompanyCustomizer =
    Customizer;


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        Customizer.init();
      },
      {
        once: true
      }
    );
  } else {
    Customizer.init();
  }


  document.addEventListener(
    'shopify:section:load',
    () => {
      Customizer.init();
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const sectionId =
        event.detail?.sectionId;

      if (!sectionId) {
        return;
      }

      document
        .querySelectorAll(
          `.jc-customizer-modal[data-section-id="${sectionId}"]`
        )
        .forEach((modalElement) => {
          modalElement.remove();
        });
    }
  );
})();